import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Seo from "@/components/Seo";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Partnership from "@/components/Partnership";
import WhyUs from "@/components/WhyUs";
import Handles from "@/components/Handles";
import HowItWorks from "@/components/HowItWorks";
import ProfitCalculator from "@/components/ProfitCalculator";
import Results from "@/components/Results";
import Testimonials from "@/components/Testimonials";
import BlogSection from "@/components/BlogSection";
import Faq from "@/components/Faq";
import Urgency from "@/components/Urgency";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import BlogPost from "@/pages/BlogPost";

const LandingPage = () => (
  <div className="min-h-screen bg-[#F7F7F9] text-[#222222]">
    <Seo />
    <Header />
    <main>
      <Hero />
      <Partnership />
      <WhyUs />
      <Handles />
      <HowItWorks />
      <ProfitCalculator />
      <Results />
      <Testimonials />
      <BlogSection />
      <Faq />
      <Urgency />
      <ContactSection />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
